import React, { Component } from 'react';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import ReactModalHeader from '../Modal/ReactModalHeader';
import ReactModalContent from '../Modal/ReactModalContent';

const StyledText = styled.div`
  font-family: Nimbus Sans Light;
  font-size: 20px;
  line-height: 26px;
  letter-spacing: 0.5px;
  color: ${tokens.ColorGrey800};
  padding-top: 32px;
  margin-bottom: 24px;

  @media (max-width: 767px) {
    font-size: 16px;
    line-height: 22px;
  }
`;

class RIGOtherIncomeModal extends Component<any, any> {
  render(): JSX.Element {
    return (
      <React.Fragment>
        <ReactModalHeader modalTitle={'Other Income'} showClose={true} />
        <ReactModalContent>
          <StyledText>
            Annual before-tax or gross amount you expect to earn from income sources other than your annual salary.
          </StyledText>
        </ReactModalContent>
      </React.Fragment>
    );
  }
}

export default RIGOtherIncomeModal;
